'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { type ReactNode, useState } from 'react';
import { CompetitionAboutSheet } from '@/components/social/competition/competition-about-sheet';
import type { TradingCompetitionSummary } from '@/components/social/competition/types';
import { AnimatedButton } from '@/components/ui/animated-button';
import { StatusBanner } from '@/components/ui/status-banner';
interface CompetitionRulesBannerProps {
  competition: TradingCompetitionSummary;
  timeZone: string;
}
export function CompetitionRulesBanner(t0) {
  const $ = _c(20);
  const {
    competition,
    timeZone
  } = t0;
  const t = useTranslations("competitions.rules");
  const [open, setOpen] = useState(false);
  let t1;
  if ($[0] !== t) {
    t1 = t("banner");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <p className="text-body text-feedback-info-content">{t1}</p>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setOpen(true);
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t("learnMore");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== open || $[8] !== t4) {
    t5 = <AnimatedButton variant="secondary" size="sm" className="shrink-0 bg-[var(--gray-0)] text-[var(--gray-900)] hover:bg-[var(--gray-50)]" aria-haspopup="dialog" aria-expanded={open} onClick={t3}>{t4}</AnimatedButton>;
    $[7] = open;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t2 || $[11] !== t5) {
    t6 = <StatusBanner tone="info"><div className="flex flex-col items-start gap-3 sm:flex-row sm:items-center sm:gap-6">{t2}{t5}</div></StatusBanner>;
    $[10] = t2;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== competition || $[14] !== open || $[15] !== timeZone) {
    t7 = <CompetitionAboutSheet competition={competition} timeZone={timeZone} open={open} onOpenChange={setOpen} initialView="rules" />;
    $[13] = competition;
    $[14] = open;
    $[15] = timeZone;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t6 || $[18] !== t7) {
    t8 = <>{t6}{t7}</>;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
}